import { type InternalAxiosRequestConfig } from 'axios';
import { type InstallationId } from '@common/types/brandedTypes';

const isReadonlyAuthPostApi = (
  url: string,
) => url.startsWith('/auth/v1/Jwt/');

const isReadonlyRestPostApi = (
  url: string,
) =>
  url.endsWith('/InstallationsInfo')
  || url.endsWith('/InstallationsInfo/own')
  || url.endsWith('/InstallationsInfo/id');

const isReadonlyPostApi = (
  url: string | undefined,
): boolean => (url ? isReadonlyAuthPostApi(url) || isReadonlyRestPostApi(url) : false);

const demoRequestInterceptor = (requestConfig: InternalAxiosRequestConfig) => {
  const { method, url } = requestConfig;

  if (method === 'get' && url?.includes('v1/Installations/Mac/')) {
    // eslint-disable-next-line no-param-reassign
    requestConfig.adapter = (config: InternalAxiosRequestConfig) =>
      Promise.resolve({
        data: {
          id: 1 as InstallationId,
          name: 'Demo WPM',
          controlUnit: 'WPMSystem',
          deviceType: 'WPL 15 AS/ACS',
          address: {
            country: 'DE',
            city: 'Holzminden',
            zip: '37603',
          },
        },
        status: 200,
        statusText: 'OK',
        headers: {},
        config,
        request: {},
      });

    return requestConfig;
  }

  if (
    !(
      method === 'get' || (method === 'post' && isReadonlyPostApi(url))
    )
  ) {
    // eslint-disable-next-line no-param-reassign
    requestConfig.adapter = (config: InternalAxiosRequestConfig) =>
      Promise.resolve({
        data: {},
        status: 200,
        statusText: 'OK',
        headers: {},
        config,
        request: {},
      });
  }

  return requestConfig;
};

export default demoRequestInterceptor;
